'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

require('./PillButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var PillButton = function PillButton(_ref) {
    var children = _ref.children,
        onClickFn = _ref.onClickFn,
        className = _ref.className;
    return _react2.default.createElement(
        _Button2.default,
        { className: (0, _classnames2.default)('PillButton', className), onClickFn: onClickFn },
        children
    );
};

// Styles
// Lib


PillButton.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    onClickFn: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = PillButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/PillButton.js
// module id = 1701
// module chunks = 0